/*
 * @Author: Vanny
 * @Date: 2019-11-06 14:09:28
 * @LastEditors: Vanny
 * @LastEditTime: 2019-11-06 14:11:56
 * @Description: 清空数据
 */
export function removeEmpty(o: Record<string, any>) {
  return Object.keys(o).reduce(
    (acc, k) => {
      if (o[k]) acc[k] = o[k];
      return acc;
    },
    {} as Record<string, any>
  );
}

export const createPropsGetter = <DP extends object>(defaultProps: DP) => {
  return <P extends Partial<DP>>(props: P) => {
    // type PropsExcludingDefaults = Pick<P, Exclude<keyof P, keyof DP>>;
    type PropsExcludingDefaults = Omit<P, keyof DP>;

    type RecomposedProps = DP & PropsExcludingDefaults;

    return (props as any) as RecomposedProps;
  };
};
